import { type BillApprovalChainOptionConstructor } from '@webapp/platform/approval-routing/entities/BillApprovalChainOption'
import { type BillApprovalChainApiModel } from '../api-models/BillApprovalChainApiModel'

export const mapBillApprovalChainApiModel = (
  model: BillApprovalChainApiModel
): BillApprovalChainOptionConstructor => ({
  id: model.id,
  name: model.name,
})
